// The kind of packages that are supported by the booking system.

export const threeMonthsPackage = "three-months";
export const sixMonthsPackage = "six-months";
export const twelveMonthsPackage = "twelve-months";
export const perUsagePackage = "usage";

export type PackageType = "three-months" | "six-months" | "twelve-months" | "usage";